import React, { useState, useEffect } from 'react';
import { IoInformationCircle } from "react-icons/io5";
import { TbListDetails } from "react-icons/tb";
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import { useNavigate } from 'react-router-dom';
import { FaPencilAlt } from "react-icons/fa";
import axios from '../../Authservices/axiosInstance';
export default function AddDeptAnnouncements() {
  const [formData, setFormData] = useState({
    title: '',
    message: '',
    category: '' // category will store the department name
  });

  const [options, setOptions] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Fetch departments from the backend
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get('https://backend.ems.uk.hiradentallab.com/api/departments');
        const departments = response.data.map(dept => ({
          value: dept.name, // Use the department name here
          label: dept.name
        }));
        setOptions(departments);
      } catch (err) {
        setError('Failed to fetch departments. Please try again.');
        console.error(err);
      }
    };

    fetchDepartments();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSelectChange = (selectedOption) => {
    setFormData({
      ...formData,
      category: selectedOption ? selectedOption.value : ''
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure department is selected
    if (!formData.category) {
      setError('Please select a department.');
      return;
    }

    try {
      const response = await axios.post('https://backend.ems.uk.hiradentallab.com/api/deptannouncements/add', {
        title: formData.title,
        message: formData.message,
        department: formData.category // Send the department name here
      });

      if (response.status === 201) {
        setShowAlert(true);
        setFormData({ title: '', message: '', category: '' });
        setTimeout(() => {
          setShowAlert(false);
          navigate('/dept-announcements');
        }, 2000);
      }
    } catch (err) {
      setError('Failed to add the announcement. Please try again.');
      console.error(err);
    }
  };

  return (
    <div className="container-fluid">
      <h1 style={{ marginTop: '60px', fontSize: '2rem', color: '#0353a4' }}>
        <IoInformationCircle className="salary-icon" /> Announcements Information
      </h1>
      <hr />
      <h2 className="salary-subtitle">
        <TbListDetails className="salary-icon" /> Announcements Details
      </h2>
      <hr />

      {/* Success Alert */}
      {showAlert && (
        <Alert variant="success">
          Department announcement added successfully!
        </Alert>
      )}

      {/* Error Alert */}
      {error && (
        <Alert variant="danger">
          {error}
        </Alert>
      )}

      <div className="table-container">
        <Form onSubmit={handleSubmit}>
          {/* Announcement Title */}
          <Form.Group controlId="title">
            <Form.Label style={{ fontWeight: 'bold' }}>
              Announcement Title <span style={{ color: 'red' }}> *</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter the announcement title"
              required
            />
          </Form.Group>

          {/* Announcement Message */}
          <Form.Group controlId="message" className="mt-3">
            <Form.Label style={{ fontWeight: 'bold' }}>
              Announcement Message <span style={{ color: 'red' }}> *</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Enter the announcement message"
              rows={3}
              required
            />
          </Form.Group>

          {/* Announcement Category */}
          <Form.Group controlId="category" className="mt-3" style={{ width: "45%" }}>
            <Form.Label style={{ fontWeight: 'bold' }}>
              Announcement For <span style={{ color: 'red' }}> *</span>
            </Form.Label>
            <Select
              id="category"
              options={options}
              onChange={handleSelectChange}
              value={options.find(option => option.value === formData.category)}
              isClearable
              placeholder="--Select--"
            />
          </Form.Group>

          {/* Submit Button */}
          <div className="py-3">
            <Button variant="primary" type="submit">
              <FaPencilAlt /> Add Announcement
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
